var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 2.1667C4.22464 2.1667 3.80072 2.3423 3.48816 2.65486C3.17559 2.96742 3 3.39134 3 3.83337V12.1667C3 12.6087 3.17559 13.0327 3.48816 13.3452C3.80072 13.6578 4.22464 13.8334 4.66667 13.8334C5.10869 13.8334 5.53262 13.6578 5.84518 13.3452C6.15774 13.0327 6.33333 12.6087 6.33333 12.1667V3.83337C6.33333 3.39134 6.15774 2.96742 5.84518 2.65486C5.53262 2.3423 5.10869 2.1667 4.66667 2.1667ZM11.3333 2.1667C10.8913 2.1667 10.4674 2.3423 10.1548 2.65486C9.84226 2.96742 9.66667 3.39134 9.66667 3.83337V12.1667C9.66667 12.6087 9.84226 13.0327 10.1548 13.3452C10.4674 13.6578 10.8913 13.8334 11.3333 13.8334C11.7754 13.8334 12.1993 13.6578 12.5118 13.3452C12.8244 13.0327 13 12.6087 13 12.1667V3.83337C13 3.39134 12.8244 2.96742 12.5118 2.65486C12.1993 2.3423 11.7754 2.1667 11.3333 2.1667Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.20dda5eed12f5199f300887d68c33dcf.svg";
export { ForwardRef as ReactComponent };